module.exports = __webpack_public_path__ + "img/tsumugi_3.d107ef3e.png";